/**
 * vasotopia-pro-tarifs.js
 * Applique automatiquement le tarif pro dégressif en fonction des mini vases dans le panier.
 * Détection : tout produit dont le handle commence par "mini-vase-" (collection mini-vases).
 * Codes : PRO6 (≥6) · PRO12 (≥1²) · PRO24 (≥2⁴) · PRO36 (≥3⁶)
 */
(function () {
  'use strict';

  var TIERS = [
    { min: 36, code: 'PRO36', price: 4.48,  pct: '-68 %' },
    { min: 24, code: 'PRO24', price: 5.10,  pct: '-64 %' },
    { min: 12, code: 'PRO12', price: 5.80,  pct: '-59 %' },
    { min: 6,  code: 'PRO6',  price: 6.60,  pct: '-53 %' },
  ];

  var APPLIED_KEY = 'vtp_pro_applied';

  function isMiniVase(item) {
    return item.handle && item.handle.indexOf('mini-vase-') === 0;
  }

  function countMiniVases(items) {
    return items.reduce(function (n, item) {
      return isMiniVase(item) ? n + item.quantity : n;
    }, 0);
  }

  function getTier(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function getNextTier(qty) {
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (qty < TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function fmt(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function currentAppliedProCode() {
    try {
      var dc = document.cookie.match(/discount_code=([^;]+)/);
      if (dc) {
        var v = decodeURIComponent(dc[1]);
        if (/^PRO(6|12|24|36)$/.test(v)) return v;
      }
    } catch (e) {}
    return sessionStorage.getItem(APPLIED_KEY) || null;
  }

  function run() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty     = countMiniVases(cart.items);
        var tier    = getTier(qty);
        var target  = tier ? tier.code : null;
        var current = currentAppliedProCode();

        if (target && target !== current) {
          sessionStorage.setItem(APPLIED_KEY, target);
          window.location.href =
            '/discount/' + target + '?redirect=' + encodeURIComponent('/cart');
          return;
        }

        if (!target && current && /^PRO/.test(current)) {
          sessionStorage.removeItem(APPLIED_KEY);
        }

        renderBanner(qty, tier);
      })
      .catch(function () {});
  }

  function renderBanner(qty, tier) {
    var existing = document.getElementById('vtp-pro-banner');
    if (existing) existing.remove();
    if (qty === 0) return;

    var next = getNextTier(qty);
    var html = '';

    if (tier) {
      var tot = qty * tier.price;
      html += '<div class="vtp-row vtp-active">';
      html += '<span class="vtp-ic">✓<\/span>';
      html += '<span class="vtp-txt">Tarif pro actif : <strong>' + fmt(tier.price) + '\/vase<\/strong>';
      html += ' (' + tier.pct + ') · ' + qty + ' mini vases · total <strong>' + fmt(tot) + '<\/strong><\/span>';
      html += '<\/div>';
      if (next) {
        var diff   = next.min - qty;
        var saving = (tier.price - next.price) * next.min;
        html += '<div class="vtp-row vtp-next">';
        html += '<span class="vtp-ic">↑<\/span>';
        html += '<span class="vtp-txt">Plus que <strong>' + diff + ' vase' + (diff > 1 ? 's' : '') + '<\/strong>';
        html += ' pour passer à <strong>' + fmt(next.price) + '\/vase<\/strong>';
        if (saving > 0) html += ' — soit <strong>' + fmt(saving) + ' de moins<\/strong> sur la commande';
        html += '<\/span><\/div>';
      }
    } else {
      var needed = 6 - qty;
      html += '<div class="vtp-row vtp-suggest">';
      html += '<span class="vtp-ic">★<\/span>';
      html += '<span class="vtp-txt">Plus que <strong>' + needed + ' vase' + (needed > 1 ? 's' : '') + '<\/strong>';
      html += ' pour débloquer le tarif pro à <strong>' + fmt(TIERS[TIERS.length - 1].price) + '\/vase<\/strong><\/span>';
      html += '<\/div>';
    }

    var banner = document.createElement('div');
    banner.id = 'vtp-pro-banner';
    banner.innerHTML = html;

    if (!document.getElementById('vtp-pro-style')) {
      var s = document.createElement('style');
      s.id = 'vtp-pro-style';
      s.textContent = '#vtp-pro-banner{font-family:inherit;margin:0 0 18px;border-radius:10px;overflow:hidden;font-size:14px;line-height:1.5}' +
        '#vtp-pro-banner .vtp-row{display:flex;align-items:flex-start;gap:10px;padding:11px 16px}' +
        '#vtp-pro-banner .vtp-active{background:#eef7f0;border-left:4px solid #3d7a4f;color:#2a4d36}' +
        '#vtp-pro-banner .vtp-next{background:#fff8f0;border-left:4px solid #d9967e;color:#5a3028}' +
        '#vtp-pro-banner .vtp-suggest{background:#f5f5ff;border-left:4px solid #9090cc;color:#3a3a6a}' +
        '#vtp-pro-banner .vtp-ic{flex-shrink:0;font-size:16px;margin-top:1px}' +
        '#vtp-pro-banner .vtp-txt{flex:1}' +
        '#vtp-pro-banner strong{font-weight:700}';
      document.head.appendChild(s);
    }

    var anchor =
      document.querySelector('.cart__items') ||
      document.querySelector('form[action="\/cart"]') ||
      document.querySelector('main') ||
      document.body;
    anchor.insertBefore(banner, anchor.firstChild);
  }

  function init() {
    if (window.location.pathname !== '/cart') return;
    run();
    document.addEventListener('cart:refresh',  run);
    document.addEventListener('cart:updated',  run);
    document.addEventListener('cart:rendered', run);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && t.closest('[data-cart-item], .cart__item, cart-items')) {
          run(); break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
